module.exports = __webpack_public_path__ + "static/media/baleia_jubarte.27039df2.png";